<template>

        <header v-if="!profileModalOpen && !isLoading">
            <profile-button v-if="hasProfile" />
            <router-link :to="{name: 'settings', params:{ lang }}" class="btn-icon" v-if="false">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 62 61">
                    <path
                        d="M55.867 24.982c-.781-3.642 2.288-9.034.211-12.052-2.075-3.027-8.208-2.084-11.333-4.105-3.014-1.96-4.618-7.98-8.374-8.674-3.757-.694-7.404 4.358-10.92 5.113-3.642.781-9.035-2.288-12.052-.212-3.017 2.077-2.084 8.208-4.105 11.334-1.96 3.014-7.971 4.62-8.664 8.376-.694 3.756 4.348 7.402 5.103 10.918.781 3.642-2.288 9.034-.212 12.051 2.077 3.018 8.209 2.085 11.334 4.106 3.014 1.96 4.618 7.98 8.374 8.674 3.757.694 7.404-4.358 10.92-5.113 3.64-.772 9.034 2.288 12.051.211 3.027-2.075 2.085-8.208 4.106-11.333 1.96-3.014 7.98-4.618 8.674-8.374.694-3.757-4.358-7.404-5.113-10.92ZM28.141 44.737c-7.956-1.468-13.216-9.11-11.748-17.065 1.469-7.956 9.11-13.216 17.066-11.748 7.956 1.469 13.216 9.11 11.748 17.066-1.469 7.956-9.11 13.216-17.066 11.747Z"/>
                </svg>
                <span class="sr-only">Réglages</span>
            </router-link>
        </header>

        <h1 :class="`logo-${lang}`" v-if="!profileModalOpen && !isLoading">
            <span class="sr-only">Mazaam Émotions</span>
        </h1>


        <nav role="navigation" class="big-buttons" v-if="!profileModalOpen  && !isLoading">
            <router-link :to="{name: 'game-1', params:{ lang }}" class="btn-image">
                <h2 class="btn-image-title">{{ copydeck.home.game1_title[lang] }}</h2>
                <img src="/images/chemin-du-coeur.jpg" width="348" height="398" alt=""/>
                <span class="btn-primary">{{ copydeck.home.btn_play[lang] }}</span>
            </router-link>
<!--            <router-link :to="{name: 'game-2', params:{ lang }}" class="btn-image">-->
<!--                <h2 class="btn-image-title">Les amis plein d'astuces</h2>-->
<!--                <img src="/images/amis-plein-astuces.jpg" width="348" height="398" alt=""/>-->
<!--                <span class="btn-primary">Jouer</span>-->
<!--            </router-link>-->
        </nav>



    <create-account v-if=" profileModalOpen && profileModalMode === 'create-account' " @created="updateDecorAndCharacter" />
    <select-account v-if=" profileModalOpen && profileModalMode === 'select-account'" @account-selected="updateDecorAndCharacter" />


    <footer v-if="!profileModalOpen && !isLoading">
        <nav role="navigation" class="footer-nav">
            <router-link :to="{name: 'parentsArea', params:{ lang }}" class="btn-secondary zone-parents">{{ copydeck.home.btn_parents[lang] }}</router-link>

            <a v-if="lang === 'en'" href="/fr" class="btn-secondary">Français</a>
            <a v-if="lang === 'fr'" href="/en" class="btn-secondary">English</a>

            <router-link :to="{name: 'credits', params:{ lang }}" class="btn-secondary">{{ copydeck.home.btn_credits[lang] }}</router-link>
        </nav>
    </footer>
</template>

<script>
import { Carousel, Navigation, Slide } from 'vue3-carousel';


export default {
    name       : "Home",
    components : { ProfileButton, CreateAccount, SelectAccount },
}
</script>

<script setup>
import { useMainStore } from "../stores/main";
import { storeToRefs }  from "pinia";
import ProfileButton    from '../components/ProfileButton.vue';
import CreateAccount    from '../components/CreateAccount.vue';
import SelectAccount    from '../components/SelectAccount.vue';
import { onMounted, computed, ref }   from "vue";
import Events from "../game/events/Events";

let store = useMainStore();
const { lang, seenHome, profileModalOpen, profileModalMode,  currentUserAccount , accounts, copydeck } = storeToRefs( store );

let emits = defineEmits( [ 'showLoading' ] );

seenHome.value = true;

let hasProfile = computed ( () => currentUserAccount.value !== false );

let isLoading = ref(false);

function updateDecorAndCharacter ()
{
    document.location.reload();
    // isLoading.value = true;
    // document.dispatchEvent(new CustomEvent( Events.UpdteSceneAndCharacter, { detail: { account: currentUserAccount.value } } ) );
    // emits( "showLoading" );
}

</script>
